import type { SxProps, Theme } from '@mui/material';

export const styles = {
    button: (theme: Theme) => ({
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: '6px',
        background: 'white',
        color: theme.palette.grey[700],
        textTransform: 'none',
        fontWeight: 500,
        fontSize: '12px',
        padding: '4px 12px',
        gap: 1,
    }),
    menu: { mt: 1 } as SxProps<Theme>,
    menuItem: { fontSize: '12px' } as SxProps<Theme>,
};
